<template lang="pug">
#modal-diagnostico-socioambiental-em-lote
    el-dialog.custom-dialog(
        :visible='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :show-close='false',
        destroy-on-close,
        width='85%',
        v-loading='isLoading'
    )
        template(slot='title')
            .dialog-header {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoEmLote') }}
        div
            p {{ $t('mensagens.diagnosticoSocioambiental.inserirArquivoXls') }}
            .body
                .import-container
                    p.sub-title
                        | {{ $t('mensagens.diagnosticoSocioambiental.importarArquivo') }}
                    .import-content
                        p.sub-title-content
                            el-icon.warning-alert-color(
                                :class='"el-icon-warning"'
                            )
                            | {{ $t('mensagens.diagnosticoSocioambiental.atencao') }}
                        p
                            | {{ $t('mensagens.diagnosticoSocioambiental.certifiqueQueAsInformacoesEstaoCorretas') }}
                        el-upload#modal-diagnostico-socioambiental-em-lote-upload.upload-demo(
                            :class='{ uploading: carregandoArquivoEmLote }',
                            v-model='fileList',
                            :disabled='carregandoArquivoEmLote',
                            drag,
                            action='alert',
                            :show-file-list='false',
                            :auto-upload='false',
                            :on-change='onLoadFile',
                            :on-remove='onRemoveFile',
                            :on-exceed='onLimitExceed',
                            :limit='1',
                            ref='upload'
                        )
                            i.el-icon-upload(style='margin-top: 40px')
                            .el-upload__text
                                .d-flex.align-items-center(
                                    v-if='nomeArquivo'
                                )
                                    span {{ nomeArquivo }}
                                    i.mdi.mdi-loading.mdi-20px.mdi-spin.ml-2(
                                        v-show='carregandoArquivoEmLote'
                                    )
                                span(v-else) {{ $t('mensagens.diagnosticoSocioambiental.uploadFile.1') }} <em class='custom-em'>{{ $t('mensagens.diagnosticoSocioambiental.uploadFile.2') }}</em>
                            p {{ $t('mensagens.diagnosticoSocioambiental.arquivoNoFormatoXls') }}
                .result-container
                    p.sub-title
                        | {{ $t('mensagens.diagnosticoSocioambiental.resultadoDiagnostico') }}
                    .result-content
                        DiagnosticoSociambientalEmLoteHistorico(
                            :statusLista='statusLista',
                            :statusListaCarregando='statusListaCarregando',
                            @atualizarLista='obterStatusCarregamentoLote()'
                        )
        footer(slot='footer')
            .custom-divider
            .footer-content
                el-button.margin-top(
                    @click='fecharModal()',
                    size='big',
                    type='outline'
                ) {{ $t('mensagens.comuns.fechar') }}
</template>

<script>
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import formatters from '@/utils/formatters';
import { timestampToDateTime } from '@/utils/filters';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

import service from '@/services/DiagnosticoSocioambientalService';
import DiagnosticoSociambientalEmLoteHistorico from '@/components/diagnosticoSocioambiental/DiagnosticoSociambientalEmLoteHistorico.vue';

export default {
    name: 'ModalDiagnosticoSociambientalEmLote',
    components: {
        DiagnosticoSociambientalEmLoteHistorico
    },
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },

    beforeDestroy() {
        disconnect();
    },
    
    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    data() {
        return {
            isLoading: false,
            fileList: [],
            tableData: [],
            statusLista: [],
            exportTable: [],
            listaDeDocumentos: [],
            percentage: 0,
            activeTab: 'cargaEmLote',
            canExport: false,
            statusListaCarregando: false,
            carregandoArquivoEmLote: false,
            carregamentoAssincrono: false,
            quantidadeItens: 0,
            nomeArquivo: null
        };
    },
    async mounted() {
        this.obterStatusCarregamentoLote();
        try {
            await connect();
        } catch {
            this.$notify.error({
                message: this.$t(
                    'mensagens.diagnosticoSocioambiental.cargaEmLote.processamentoLoteErro'
                )
            });
        }
        subscribe(
            `${this.usuarioLogado.idKeyCloack}/diagnosticosocioambiental/lote`,
            response => {
                const dados = JSON.parse(response);
                const index = this.statusLista.findIndex(status => status.id === dados.id);
                this.$set(this.statusLista, index, {
                    ...this.statusLista[index],
                    ultimaLinha: dados.total,
                    status_atualizacao_processamento: dados.status,
                    progress: dados.progress,
                    labelProgress: dados.labelProgress
                });
            }
        );
    },
    methods: {
        changeTiteUploader(file) {
            this.nomeArquivo = file ? file.name : null;
        },
        changeTabTrigger() {
            if (this.activeTab === 'historico') {
                this.obterStatusCarregamentoLote();
            }
        },
        resetModal() {
            this.fileList = [];
            this.tableData = [];
            this.activeTab = 'cargaEmLote';
            this.carregamentoAssincrono = false;
            this.canExport = false;
            this.statusLista = [];
            this.statusListaCarregando = false;
            this.exportTable = [];
            this.nomeArquivo = null;
            this.quantidadeItens = 0;
        },
        fecharModal() {
            this.$emit('voltar');
            this.resetModal();
        },

        onLimitExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.diagnosticoSocioambiental.somenteUmArquivoPorVez'
                )
            });
        },

        onRemoveFile() {
            this.fileList = [];
            this.tableData = [];
            this.exportTable = [];
            this.canExport = false;
            this.quantidadeItens = 0;
            this.nomeArquivo = null;
            this.changeTiteUploader();
            this.carregamentoAssincrono = false;
            this.$refs.upload.clearFiles();
            if (this.carregamentoAssincrono) {
                this.carregamentoAssincrono = false;
                this.tableData = this.tableData.map(item => {
                    const itemEmProcessamento =
                        item['Análise Socioambiental'] ===
                        this.$t(
                            'mensagens.diagnosticoSocioambiental.processando'
                        );

                    return itemEmProcessamento
                        ? {
                              ...item,
                              'Análise Socioambiental': this.$t(
                                  'mensagens.diagnosticoSocioambiental.cancelado'
                              )
                          }
                        : item;
                });
            }
        },

        async processarArquivoEmLoteHistorico(file) {
            this.carregandoArquivoEmLote = true;
            try {
                await service.processamentoLote(file);
                this.obterStatusCarregamentoLote();
                this.activeTab = 'historico';
                this.$notify.success({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.processamentoLoteSucesso'
                    )
                });
            } catch (error) {
                if (error.code === 'CANCELLED') {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.diagnosticoSocioambiental.cargaEmLote.processamentoLoteSucesso'
                        )
                    });
                    this.obterStatusCarregamentoLote();
                    this.activeTab = 'historico';
                } else {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.diagnosticoSocioambiental.cargaEmLote.processamentoLoteErro'
                        )
                    });
                }
            } finally {
                this.carregandoArquivoEmLote = false;
                this.onRemoveFile();
                this.nomeArquivo = null;
            }
        },
        formatarLocalidade({ municipio, estado }) {
            return municipio && estado
                ? `${municipio}/${estado}`
                : municipio || estado || '-';
        },
        onLoadFile(file) {
            if (this.validateFileFormat(file)) {
                const reader = new FileReader();
                this.canExport = false;
                reader.onload = async e => {
                    const arrayBuffer = e.target.result;
                    const data = new Uint8Array(arrayBuffer);
                    const workbook = XLSX.read(data, { type: 'array' });

                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];

                    const jsonData = XLSX.utils.sheet_to_json(sheet, {
                        header: 1
                    });

                    const headerRow = jsonData[0];
                    const carCpfCnpjIndex = headerRow.findIndex(
                        column => column === 'CAR/CPF/CNPJ'
                    );

                    const jsonDataFormatada = jsonData
                        .filter(item => item.length > 0)
                        .slice(1);

                    if (
                        carCpfCnpjIndex === -1 ||
                        jsonDataFormatada.length === 0
                    ) {
                        this.showWarningMessage();
                        return;
                    }

                    this.changeTiteUploader(file);
                    this.quantidadeItens = jsonDataFormatada.length;

                    return this.processarArquivoEmLoteHistorico(file);
                };

                reader.readAsArrayBuffer(file.raw);
            }
        },

        exportToExcel() {
            const filename = 'diagnostico-socioambiental-lote.xlsx';

            const dadosGeraisHeaders = [
                this.$t('mensagens.diagnosticoSocioambiental.municipioUf'),
                this.$t('mensagens.diagnosticoSocioambiental.areaHa'),
                this.$t('mensagens.diagnosticoSocioambiental.bioma'),
                this.$t('mensagens.diagnosticoSocioambiental.faixaFronteira'),
                this.$t('mensagens.diagnosticoSocioambiental.moduloFiscal'),
                this.$t('mensagens.diagnosticoSocioambiental.situacao')
            ];
            const diagnosHeaders = this.getUniqueCamadaHeaders(
                this.exportTable
            );

            const headerRow1 = [
                this.$t('mensagens.diagnosticoSocioambiental.itemAnalisado'),
                '',
                this.$t(
                    'mensagens.diagnosticoSocioambiental.informacoesGerais'
                ),
                '',
                '',
                '',
                '',
                '',
                this.$t(
                    'mensagens.diagnosticoSocioambiental.criticidadeDeAcordoComProtocolo'
                )
            ];

            const headerRow2 = [
                this.$t('mensagens.diagnosticoSocioambiental.carDocumento'),
                this.$t('mensagens.diagnosticoSocioambiental.resultado'),
                ...dadosGeraisHeaders,
                ...diagnosHeaders
            ];

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            worksheet.addRows([headerRow1, headerRow2]);

            worksheet.getRow(1).eachCell(cell => {
                cell.font = { bold: true };
            });
            worksheet.getRow(2).eachCell(cell => {
                cell.font = { bold: true };
            });

            const columnWidths = [
                { width: 30 },
                { width: 15 },
                { width: 20 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                ...Array.from({ length: diagnosHeaders.length }, () => ({
                    width: 20
                }))
            ];
            worksheet.columns = columnWidths;

            const maxLengths = new Array(headerRow2.length).fill(0);

            headerRow2.forEach((header, index) => {
                maxLengths[index] = Math.max(
                    maxLengths[index],
                    String(header).length
                );
            });

            this.exportTable.forEach(row => {
                const carDocumento = row['CAR/Documento'] || '-';
                const resultado = row['resultado'] || '-';

                const dadosGeraisValues = [
                    row.localidade || '-',
                    row.areaHa || '-',
                    row.bioma || '-',
                    row.faixaFronteira || '-',
                    row.moduloFiscal || '-',
                    row.situacao || '-'
                ];
                const diagnosValues = this.extractCamadaValues(
                    row,
                    diagnosHeaders
                );

                const finalRow = [
                    carDocumento,
                    resultado,
                    ...dadosGeraisValues,
                    ...diagnosValues
                ];

                finalRow.forEach((value, index) => {
                    const strValue = String(value);
                    maxLengths[index] = Math.max(
                        maxLengths[index],
                        strValue.length
                    );
                });

                worksheet.addRow(finalRow);
            });

            maxLengths.forEach((length, index) => {
                const adjustedWidth = Math.min(
                    Math.max(length * 1.2, columnWidths[index]?.width || 10),
                    60
                );
                worksheet.getColumn(index + 1).width = adjustedWidth;
            });

            worksheet.mergeCells('C1:H1');
            if (diagnosHeaders.length > 0) {
                const firstDiagnosCol = 9;
                const lastDiagnosCol =
                    firstDiagnosCol + diagnosHeaders.length - 1;
                if (lastDiagnosCol > firstDiagnosCol) {
                    worksheet.mergeCells(
                        `${firstDiagnosCol}1:${lastDiagnosCol}1`
                    );
                }
            }

            worksheet.getRow(1).eachCell(cell => {
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
            worksheet.getRow(2).eachCell(cell => {
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(link.href);
            });
        },

        formatFileName(filePath) {
            if (!filePath || typeof filePath !== 'string') return '';
            return filePath.split(/[/\\]/).pop();
        },
        async obterStatusCarregamentoLote() {
            this.statusListaCarregando = true;
            service
                .statusProcessamentoEmLote()
                .then(({ data }) => {
                    this.statusLista = data.map(item => ({
                        ...item,
                        nome_arquivo:
                            this.formatFileName(item.nome_arquivo) || '-',
                        inicio_processamento:
                            timestampToDateTime(item.inicio_processamento) ||
                            '-',
                        termino_processamento:
                            timestampToDateTime(item.termino_processamento) ||
                            '-',
                        atualizacao_processamento:
                            timestampToDateTime(
                                item.atualizacao_processamento
                            ) || '-'
                    }));
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.diagnosticoSocioambiental.cargaEmLote.statusProcessamentoLoteErro'
                        )
                    });
                })
                .finally(() => {
                    this.statusListaCarregando = false;
                });
        },

        showWarningMessage() {
            this.onRemoveFile();
            this.$notify.warning({
                message: this.$t(
                    'mensagens.diagnosticoSocioambiental.erro.arquivoInvalido'
                )
            });
        },

        formatTableData(row, column, data, index) {
            if (/^\d{11}$/.test(data) || /^\d{14}$/.test(data)) {
                return formatters.numeralStringFormatTocpfCnpj(data);
            } else if (/^[A-Z]{2}\d{7}.+$/.test(data)) {
                return formatters.formatCar(data);
            } else {
                return data;
            }
        },

        formatCAR(item) {
            return formatters.formatCar(item);
        },

        validateFileFormat(file) {
            const validExtensions = ['.xls', '.xlsx'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.'));

            if (validExtensions.includes(fileExtension)) {
                return true;
            } else {
                this.onRemoveFile();
                this.$notify.error(
                    this.$t(
                        'mensagens.diagnosticoSocioambiental.somenteArquivosXlsSaoPermitidos'
                    )
                );
                return false;
            }
        },

        getUniqueCamadaHeaders(data) {
            const dadosGeraisKeys = new Set([
                'localidade',
                'areaHa',
                'bioma',
                'faixaFronteira',
                'moduloFiscal',
                'situacao',
                'resultado'
            ]);
            const headersSet = new Set();
            for (const row of data) {
                for (const key in row) {
                    if (!key.startsWith('CAR/') && !dadosGeraisKeys.has(key)) {
                        headersSet.add(key);
                    }
                }
            }
            return [...headersSet];
        },
        determineMaxNivelAlerta(row) {
            const levelsPriority = ['ALTO', 'MEDIO', 'MEDIO_ALTO', 'BAIXO'];

            for (const level of levelsPriority) {
                for (const key in row) {
                    if (row[key] === level) {
                        return this.determineMaxAlert(level);
                    }
                }
            }
            return this.$t(
                'mensagens.diagnosticoSocioambiental.naoEncontradoResultadoIndisponivel'
            );
        },

        determineMaxAlert(str) {
            if (!str) {
                return '-';
            }

            if (str === 'ALTO' || str === 'MEDIO_ALTO') {
                return this.$t(
                    'mensagens.diagnosticoSocioambiental.inconforme'
                );
            }
            if (str === 'MEDIO' || str === 'BAIXO') {
                return this.$t('mensagens.diagnosticoSocioambiental.conforme');
            }
            return this.$t(
                'mensagens.diagnosticoSocioambiental.naoEncontradoResultadoIndisponivel'
            );
        },

        extractCamadaValues(row, headers) {
            const hasNivelAlerta = headers.some(header => row[header]);

            if (!hasNivelAlerta) {
                return headers.map(() => ' - ');
            }

            return headers.map(header => {
                return row[header]
                    ? this.determineMaxAlert(row[header])
                    : ' - ';
            });
        }
    }
};
</script>

<style lang="scss" slot-scope>
#modal-diagnostico-socioambiental-em-lote {
    ::v-deep .el-dialog__body {
        padding: 0px;
    }

    .aviso-quantidade {
        padding-left: 4px;
        margin-top: 20px;
        word-break: normal;
        display: flex;
        align-items: center;
        gap: 12px;

        i {
            font-size: 20px;
        }
    }

    .el-tabs__active-bar {
        background-color: var(--menu-item-hover);
        height: 3px;
    }

    .sizing-overflow {
        height: 360px;
        overflow-y: auto;
    }

    .loading {
        margin-right: 5px;
    }

    .processing {
        font-size: 15px;
    }

    .high {
        color: rgba(236, 50, 50, 1);
        font-size: 20px;
    }

    .failed {
        color: rgba(116, 15, 15, 1);
        font-size: 20px;
    }

    .success {
        color: rgba(53, 145, 56, 1);
        font-size: 20px;
        margin-left: 5px;
    }

    .medium {
        color: rgba(254, 197, 86, 1);
        font-size: 20px;
        overflow-wrap: break-word !important;
    }

    .canceled {
        color: #686868;
        font-size: 20px;
        overflow-wrap: break-word !important;
    }

    .body {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
    }

    .el-upload__text {
        font-size: 16px;
    }

    .warning-alert-color {
        margin-right: 5px;
        color: rgba(221, 172, 68, 1) !important;
    }

    .custom-em {
        color: rgba(39, 111, 218, 1) !important;
    }

    .el-dialog__footer {
        padding: 0;
    }

    .sub-text-footer {
        font-size: 14px;
        display: grid;
        grid-template-columns: repeat(3, 0.8fr) 2fr;
        place-items: center;
        white-space: nowrap;

        div:not(:last-child) {
            padding-right: 20px;
        }

        div:is(:last-child) {
            padding-left: 10px;
        }

        div:not(:first-child) {
            border-left: 1px solid rgba(0, 0, 0, 0.322);
            padding-left: 20px;
        }

        div {
            display: flex;
            align-items: center;

            span {
                padding-right: 3px;
            }
        }
    }

    .sub-title-content {
        font-family: Roboto;
        font-size: 14px;
        color: #000000;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
    }

    .sub-title-footer {
        font-family: Roboto;
        font-size: 14px;
        color: #00413c;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        margin-left: 10px;
    }

    .import-container {
        width: 38%;
        height: 500px;
    }

    .import-content {
        width: 100%;
        padding: 15px;
        height: 90%;
        border: 1px solid rgba(117, 117, 117, 0.247);
        border-radius: 5px;
    }

    .result-container {
        width: 61%;
        height: 450px;
    }

    .result-content {
        width: 100%;
        height: 100%;
        border: 1px solid rgba(117, 117, 117, 0.247);
        border-radius: 5px;
    }

    .footer-content {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding: 10px 20px;
    }

    .custom-divider {
        width: 100%;
        background-color: #dcdfe6;
        height: 1px;
    }

    .content {
        overflow: auto;
        max-height: 250px;
    }

    .margin-top {
        margin-top: 16px;
    }

    .margin-left {
        margin-left: 20px;
    }

    .custom-cursor {
        cursor: pointer;
    }

    .alert-container {
        line-height: 1rem;
    }

    .alert-footer {
        display: flex;
    }

    .footer-label {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-right: 5px;
        font-size: 13.5px;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        border-color: blue !important;
        background-color: blue !important;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner::after {
        border-color: blue !important;
        background-color: blue !important;
    }

    .custom-expanded-table {
        margin-top: -20px;
    }

    .custom-icon {
        margin-right: 9px;
        vertical-align: middle;
        filter: brightness(0) invert(1);
    }

    .radio-group-container {
        max-width: 510px;
        height: 10px;
        display: flex;
        justify-content: space-between;
    }

    .custom-buttom:hover .custom-icon {
        filter: none;
    }

    .lyra-icon {
        cursor: pointer;
    }

    .menu-description {
        font-weight: 400;
        font-size: 16px;
        font-family: 'Roboto', 'sans serif';
    }

    .radio-spacing {
        margin-right: 10px;
    }

    .dialog-header {
        background-color: #e9e9e9;
        color: var(--primary);
        padding: 15px;
        margin: -20px -20px 20px -20px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .el-dialog {
        margin-top: 2vh !important;
    }

    .custom-dialog {
        border-radius: 5px;
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    .view-title {
        margin-left: 15px;
        font-family: 'Roboto', 'sans serif';
        font-size: 16px;
        font-weight: 500;
    }

    .sub-title {
        font-family: 'Roboto', 'sans serif';
        font-weight: 500;
        color: #000000;
    }

    .alert-title {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-top: 35px;
    }

    .alert-description {
        font-family: 'Roboto', 'sans serif';
        color: #000000;
        font-weight: 300;
    }

    .el-table {
        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }

    #modal-diagnostico-socioambiental-em-lote-upload.uploading {
        cursor: not-allowed;

        .el-upload,
        .el-upload-dragger {
            cursor: not-allowed;
        }

        .el-upload__text {
            color: #1b1b1b;
        }

        .el-icon-upload {
            opacity: 0.3;
        }

        p {
            opacity: 0.3;
        }
    }

    #modal-diagnostico-socioambiental-em-lote-upload {
        .el-upload-dragger {
            height: 300px;
        }
    }
}
</style>
